import * as React from 'react';
import { IActionAfterViewObserverProps } from '@cian/action-after-viewed-component';

export function ActionAfterViewObserver({ callback, children }: IActionAfterViewObserverProps) {
  React.useEffect(() => {
    callback();
  }, [callback]);

  return <div>{children}</div>;
}

export const ActionAfterViewed = ActionAfterViewObserver;
